import splitPane from "vue-splitpane"; //分割拖拽面板

import createHttp from "./src/utils/httpRequest.js"; //axios 请求实例$http

import VueCookie from "vue-cookie"; //cookie 依赖

import { getAppName, getUid, isAuth } from "./src/utils";

// import ElementUI from './src/utils/ElementUI'
import ElementUI from "element-ui";

/**
 * 引入组件
 */
import AceElectronicSignature from "./packages/business/electronic-signature";
import AceSelectUser from "./packages/business/select-user"; //选择用户
import { AceUpload, AceFileReview } from "./packages/business/uploader"; //选择用户
import AceButton from "./packages/form/Button"; //按钮
import AceCascader from "./packages/form/Cascader"; //级联选择器
import AceCheckbox from "./packages/form/Checkbox"; //多选框
import AceCheckboxButton from "./packages/form/CheckboxButton"; // 多选按钮
import AceCheckboxGroup from "./packages/form/CheckboxGroup"; //多选框组
import AceColorPicker from "./packages/form/ColorPicker"; //颜色选择器
import AceDatePicker from "./packages/form/DatePicker"; //日期选择器
import AceInput from "./packages/form/Input"; //输入框
import AceInputNumber from "./packages/form/Number"; //数字输入框
import AceRadio from "./packages/form/Radio"; //单选框
import AceRadioButton from "./packages/form/RadioButton"; //单选框
import AceRadioGroup from "./packages/form/RadioGroup"; //单选框
import AceRate from "./packages/form/Rate"; //评分
import AceSelect from "./packages/form/Select"; //选择框
import AceOption from "./packages/form/Option"; //选择项
import AceSlider from "./packages/form/Slider"; //滑块
import AceSwitch from "./packages/form/Switch"; //开关
import AceTimePicker from "./packages/form/TimePicker"; //时间选择器1
import AceTimeSelect from "./packages/form/TimeSelect"; //时间选择器2
import AceIconSelector from "./packages/business/icon-selector"; //图标选择器
import AceDataSourceFiledSelector from "./packages/business/data-source-filed-selector"; //数据源字段选择
import AcePermissionSelector from "./packages/business/permission-selector"; //权限选择
import AceDataSourceTableSelector from "./packages/business/data-source-table-selector"; //数据源表选择
import AceIframeView from "./packages/business/iframe-view"; //数据源表选择
import AceTableRender from "./packages/business/table-render"; //数据源表选择
import { AceFormRender, AceFlowFormRender } from "./packages/business/form-render"; //数据源表选择
/**
 * 引入指令
 */
import { auth } from "./src/directives/Auth"; //v-auth 权限
import DragDialog from "./src/directives/DragDialog"; //弹窗拖动

const components = [
  AceElectronicSignature,
  AceSelectUser,
  AceUpload,
  AceFileReview,
  AceButton,
  AceCascader,
  AceCheckbox,
  AceCheckboxGroup,
  AceColorPicker,
  AceDatePicker,
  AceInput,
  AceInputNumber,
  AceCheckboxButton,
  AceRadio,
  AceRadioButton,
  AceRadioGroup,
  AceRate,
  AceSelect,
  AceOption,
  AceSlider,
  AceSwitch,
  AceTimePicker,
  AceTimeSelect,
  AceDataSourceFiledSelector,
  AcePermissionSelector,
  AceDataSourceTableSelector,
  AceIframeView,
  AceTableRender,
  AceFormRender,
  AceFlowFormRender,
  AceIconSelector,
];

const directives = [auth, DragDialog];

/**
 *
 * @param {*} Vue
 * @param {Object} opts ace-ui配置项
 * @param {Boolean} opts.createAxiosInstance 是否创建 Axios 实例
 */
const install = function (Vue, opts = { appName: "", createRequestInstance: true, httpRequestUrl: "", fileUploaderUrl: "" }) {
  if (opts.createRequestInstance) {
    //如果开启创建Axios实例 则执行以下逻辑
    createHttp(Vue, {
      httpRequestUrl: opts.httpRequestUrl,
      fileUploaderUrl: opts.fileUploaderUrl,
      appName: opts.appName,
    });
  }
  Vue.prototype.$httpRequestUrl = opts.httpRequestUrl; //请求地址暴露给全局
  //   Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 };//element 全局设置
  Vue.prototype.$appName = opts.appName ? opts.appName : getAppName(); //应用名
  Vue.prototype.$isAuth = isAuth; //判断是否拥有权限方法
  Vue.prototype.$getUid = getUid; //获取 uid 方法
  Vue.use(VueCookie); //cookie
  Vue.use(ElementUI, {
    size: "small",
    zIndex: 3000,
  }); //注册element组件、命令、全局变量
  Vue.component("splitPane", splitPane); //分割面板
  /* 指令统一注册 */
  directives.forEach((directive) => {
    Vue.directive(directive.name, directive);
  });
  /* 组件统一注册 */
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};

/* 判断全局是否有vue */
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  version: "0.4.5",
  install,
  AceElectronicSignature,
  AceSelectUser,
  AceUpload,
  AceFileReview,
  AceButton,
  AceCascader,
  AceCheckbox,
  AceCheckboxGroup,
  AceColorPicker,
  AceDatePicker,
  AceInput,
  AceInputNumber,
  AceCheckboxButton,
  AceRadio,
  AceRadioButton,
  AceRadioGroup,
  AceRate,
  AceSelect,
  AceDataSourceFiledSelector,
  AceDataSourceTableSelector,
  AceIframeView,
  AceTableRender,
  AceFormRender,
  AceFlowFormRender,
};
